export default {
  backToProjects: "Retour",
}